<div [ngSwitch]="authPage">
  <div *ngSwitchCase="'login'">
    <form autocomplete="off" class="p-fluid text-sm" [formGroup]="loginForm" (ngSubmit)="login()">
      <div class="field">
        <label>{{ 'AUTH.USERNAME_OR_EMAIL' | translate }}</label>
        <input id="login" formControlName="login" type="text" pInputText />
      </div>
      <div class="field mb-4">
        <label>{{ 'AUTH.PASSWORD' | translate }}</label>
        <p-password
          id="password"
          formControlName="password"
          [ngClass]="{ 'has-error': invalidLogin }"
          (keyup)="onType()"
          [toggleMask]="true"
          [feedback]="false"
        ></p-password>
      </div>
      <button pButton pRipple type="submit" [label]="'AUTH.BUTTON' | translate" class="p-button-warning"></button>
      <p class="text-xxs mt-2">
        {{ 'AUTH.TERMS.AGREEMENT' | translate }}
        <a [href]="TERMS" target="_blank" class="underline">{{ 'AUTH.TERMS.LINK' | translate }}</a>
        {{ 'AUTH.TERMS.OF_PLATFORM' | translate }}
      </p>
    </form>
    <div class="flex flex-column align-items-center justify-content-center">
      <fp-google-login-button [lang]="translate.getCurrentLang()"></fp-google-login-button>
      <fp-linkedin-login-button [lang]="translate.getCurrentLang()"></fp-linkedin-login-button>
    </div>
    <div (click)="authPage = 'resetPassword'" class="text-sm underlined mt-3" style="cursor: pointer">
      {{ 'AUTH.FORGOT_PASSWORD' | translate }}
    </div>

    <footer class="yellow-back text-sm font-bold text-center -mx-5 -mb-6 mt-4 p-3">
      <p class="mb-0">
        {{ 'AUTH.NO_ACCOUNT' | translate }}
        <a [href]="LEADSIGNUP" class="underlined" style="cursor: pointer">{{ 'AUTH.CREATE_ACCOUNT.BUTTON' | translate }}</a>
      </p>
    </footer>
  </div>

  <div *ngSwitchCase="'resetPassword'">
    <form autocomplete="off" class="p-fluid text-sm" [formGroup]="resetPasswordForm" (ngSubmit)="resetPassword()">
      <div class="field mb-4">
        <label>{{ 'AUTH.EMAIL' | translate }}</label>
        <input formControlName="email" type="text" pInputText />
      </div>
      <button pButton pRipple type="submit" [label]="'AUTH.RESET_PASSWORD.BUTTON' | translate" class="p-button-warning"></button>
      <p
        *ngIf="message"
        class="py-3 text-sm"
        [ngClass]="errorMessage ? 'error-box' : 'success-box text-center'"
        [innerHTML]="message | translate: { email: email }"
      ></p>
      <p *ngIf="!message" class="text-xxs mt-2">
        {{ 'AUTH.TERMS.AGREEMENT' | translate }}
        <a [href]="TERMS" target="_blank" class="underline">{{ 'AUTH.TERMS.LINK' | translate }}</a>
        {{ 'AUTH.TERMS.OF_PLATFORM' | translate }}
      </p>
    </form>
    <div (click)="authPage = 'login'" class="text-sm underlined mt-3" style="cursor: pointer">{{ 'AUTH.BUTTON' | translate }}</div>
  </div>
</div>
